import { configureStore as createReduxStore } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';
import type { History } from 'history';
import { apiMiddleware as reduxApiMiddleware } from 'redux-api-middleware';
import { tracking as paymentsMiddlewareTracking } from '@common/middleware/tracking';
import rootReducer from '@common/reducers';

export default function configureStore(initialState: any, history: History) {
  const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({ history });

  const middleware = [reduxApiMiddleware, paymentsMiddlewareTracking];
  if (__BROWSER__) {
    middleware.push(routerMiddleware);
  }

  const store = createReduxStore({
    reducer: rootReducer(routerReducer),
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(middleware),
    devTools: __DEV__,
  });

  return { store, history: createReduxHistory(store) };
}
